module.exports = __webpack_public_path__ + "img/Group_1.d1cdf0f4.png";